export default __webpack_public_path__ + "static/Loblaws-daa0835afa0d7dcec6482e41106b8677.png";